module.exports = __webpack_public_path__ + "img/community_social.81f74f6d.png";